import { useRef, useState } from "react";
import { Camera, ImagePlus, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { compressImage, addUploadTime } from "@/lib/imageTools";

export const uploadPhoto = async (analysisId, file, kind, requestId) => {
  const t = performance.now();
  const fd = new FormData();
  fd.append("file", file);
  fd.append("kind", kind);
  if (requestId) fd.append("request_id", requestId);
  await api.post(`/analyses/${analysisId}/photos`, fd);
  addUploadTime(analysisId, Math.round(performance.now() - t));
};

export default function PhotoUploader({ analysisId, kind, requestId, onUploaded, compact, max = 5, testid = "photo-uploader" }) {
  const cam = useRef(null);
  const gal = useRef(null);
  const [busy, setBusy] = useState(false);

  const upload = async (files) => {
    if (!files?.length) return;
    setBusy(true);
    try {
      for (const f of Array.from(files).slice(0, max)) {
        const t = performance.now();
        const small = await compressImage(f);
        addUploadTime(analysisId, Math.round(performance.now() - t));
        await uploadPhoto(analysisId, small, kind, requestId);
      }
      onUploaded?.();
    } catch (e) {
      toast.error(errMsg(e));
    } finally {
      setBusy(false);
      if (cam.current) cam.current.value = "";
      if (gal.current) gal.current.value = "";
    }
  };

  return (
    <div className={`grid grid-cols-2 gap-2 ${compact ? "" : "mt-3"}`} data-testid={testid}>
      <input ref={cam} type="file" accept="image/*" capture="environment" hidden onChange={(e) => upload(e.target.files)} data-testid={`${testid}-camera-input`} />
      <input ref={gal} type="file" accept="image/*" multiple={max > 1} hidden onChange={(e) => upload(e.target.files)} data-testid={`${testid}-gallery-input`} />
      <button type="button" disabled={busy} onClick={() => cam.current?.click()} className="btn-primary min-h-[48px] !text-base" data-testid={`${testid}-camera-button`}>
        {busy ? <Loader2 size={18} className="animate-spin" /> : <Camera size={18} />} Scatta
      </button>
      <button type="button" disabled={busy} onClick={() => gal.current?.click()} className="btn-secondary min-h-[48px] !text-base bg-white" data-testid={`${testid}-gallery-button`}>
        <ImagePlus size={18} /> Galleria
      </button>
    </div>
  );
}
